import React from "react";
import { IndeterminateCheckbox } from "./IndeterminateCheckbox";

export const SelectionHeader = ({ getToggleAllRowsSelectedProps }) => {
  return <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />;
};
